// extracted by mini-css-extract-plugin
export default {"notesZone":"NotesArea_notesZone__e3Lvq","groupNameTab":"NotesArea_groupNameTab__S2EOB","notesBox":"NotesArea_notesBox__vKIGb","groupError":"NotesArea_groupError__NLYkk"};